module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('myo-sidebar', [_c('div', [_c('div', {
    staticClass: "text-grey pt3 pl3 pr3 pb1"
  }, [_vm._v("Innstillinger")]), _vm._v(" "), _c('router-link', {
    staticClass: "myo-list-item",
    attrs: {
      "to": "/app/settings/my-profile"
    }
  }, [_vm._v("Min profil")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "p3"
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b703b48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/templates/Settings.vue
// module id = 640
// module chunks = 1